// extracted by mini-css-extract-plugin
export default {"blogEntry":"blogEntry__24_Rs"};